var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loaging_block"},[_c('Loading')],1),_vm._v(" "),_c('div',{staticClass:"loaging_block"},[_c('SmallLoading')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }